"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var format_price_1 = __importDefault(require("../../../utils/format-price"));
exports.default = (function (_a) {
    var _b, _c;
    var quickAddOnProduct = _a.quickAddOnProduct, processAddToBundle = _a.processAddToBundle, bundleType = _a.bundleType;
    // because variants can be grouped in a kit, we need to calculate the total price & compareAtPrice when bundled together
    var _d = quickAddOnProduct.variants.reduce(function (acc, variant) {
        acc.price += Number(variant.price);
        acc.compareAtPrice += Number(variant.compare_at_price);
        return acc;
    }, { price: 0, compareAtPrice: 0 }), price = _d.price, compareAtPrice = _d.compareAtPrice;
    // flags denote the why the variant is special or being offered as a quick add-on
    // e.g. "Most Popular" or "Selling Quickly"
    var flags = quickAddOnProduct.flags;
    var featuredFlag = (flags === null || flags === void 0 ? void 0 : flags.length) ? flags[0].toUpperCase() : '';
    var handleAddToBundle = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'quickAddOn__productsAdded', bundleType: bundleType, products: quickAddOnProduct.variants });
                    return [4 /*yield*/, processAddToBundle(quickAddOnProduct)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var productName = (function () {
        var productTitle = quickAddOnProduct.title || quickAddOnProduct.variants[0].product.title;
        if (!productTitle) {
            return '';
        }
        var cardTitle = productTitle.split(/\(.+?\)/).join('');
        // make sure product name is 25 characters or less to fit nicely in card
        return cardTitle.length > 25 ? "".concat(cardTitle.substr(0, 22), "...") : cardTitle;
    })();
    var optionsTitle = (function () {
        var option1 = quickAddOnProduct.variants[0].option1;
        var option2 = quickAddOnProduct.variants[0].option2;
        // if we have more than one variant for the quickAddOnProduct, then it's a grouped quickAddOn (like a kit)
        if (quickAddOnProduct.variants.length > 1 || option1 === 'Default Title') {
            return '';
        }
        var title = option2 ? "".concat(option1, " / ").concat(option2) : option1;
        // make sure variant options is 20 characters or less to fit nicely in card
        return title.length > 20 ? "".concat(title.substr(0, 17), "...") : title;
    })();
    // first try the quickAddOnImage. if it doesn't exist, then use the first variant's image
    var productImageSrc = quickAddOnProduct.imgUrl || ((_b = quickAddOnProduct.variants[0].featured_image) === null || _b === void 0 ? void 0 : _b.src) || ((_c = quickAddOnProduct.variants[0].product.image) === null || _c === void 0 ? void 0 : _c.src);
    return (React.createElement("div", { className: 'bg-transparent-light-wisteria border-wisteria margin-horizontal-1 quick-add-on-card flex-container padding-vertical-2', style: { justifyContent: 'space-around' }, "data-equalizer-watch": 'item' },
        React.createElement("div", { style: { margin: 'auto 0' } },
            React.createElement("img", { src: productImageSrc, style: { maxHeight: '100px', maxWidth: '68px', width: 'auto' } })),
        React.createElement("div", { style: { margin: 'auto 0' } },
            React.createElement("div", { className: 'flag' }, featuredFlag),
            React.createElement("div", { className: 'title' }, productName),
            React.createElement("div", { className: 'font-lighter', style: { fontSize: '12px' } }, optionsTitle),
            React.createElement("div", { className: 'price padding-top-2' },
                compareAtPrice > 0 && (React.createElement("span", { className: 'text-gray padding-right-1', style: { textDecoration: 'line-through' } }, (0, format_price_1.default)(compareAtPrice.toFixed(2)))),
                React.createElement("span", { className: 'text-wisteria' }, (0, format_price_1.default)(price.toFixed(2))))),
        React.createElement("div", { className: 'padding-horizontal-1', style: { width: '40px', margin: 'auto 0' } },
            React.createElement("a", { id: 'add-product-recommendation' // for GA
                , onClick: handleAddToBundle },
                React.createElement("img", { src: window.accountApp.iconUrls.add, style: { height: '24px' } })))));
});
